var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDe00(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.24,26.09c-.14,0-.28-.04-.41-.12L.35,6.73c-.35-.23-.45-.69-.23-1.05.23-.35.69-.45,1.05-.23l28.49,19.24c.35.23.45.69.23,1.05-.14.23-.39.35-.64.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.82,8.75h18.95v12.8l1.49,1.01V7.96c0-.43-.33-.79-.75-.79h-3.28v-2.51c0-.42-.34-.76-.76-.76h-4.56c-.42,0-.76.34-.76.76v2.51h-6.04v-2.51c0-.42-.34-.76-.76-.76h-4.56c-.42,0-.76.34-.76.76v2.51h-.57l2.33,1.57Zm11.86-3.33h3.04v1.76h-3.04v-1.76Zm-12.11,0h3.04v1.76h-3.04v-1.76Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m23.78,23.76H3.53v-13.67l-1.49-1.01v15.47c0,.43.33.79.75.79h23.32l-2.33-1.57Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m24.25,17.11h-4.56c-.42,0-.76-.34-.76-.76s.34-.76.76-.76h4.56c.42,0,.76.34.76.76s-.34.76-.76.76Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m10.58,15.59h-1.52v-1.52c0-.42-.34-.76-.76-.76s-.76.34-.76.76v1.52h-1.52c-.42,0-.76.34-.76.76s.34.76.76.76h1.52v1.52c0,.42.34.76.76.76s.76-.34.76-.76v-1.52h1.52c.42,0,.76-.34.76-.76s-.34-.76-.76-.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe00);
export default __webpack_public_path__ + "static/media/DE00.150b7547cc2ccc24622ef8a7c85904dd.svg";
export { ForwardRef as ReactComponent };